import { shortenNumber } from '@ydistri/generic-utils';
import { StatisticItem } from '../StatisticsSummary';
import { CalculationStatisticRouteResponse } from '@ydistri/api-sdk';

export const buildRouteStats = (
  routes: CalculationStatisticRouteResponse[] | undefined | null,
  currency: string,
): StatisticItem[] => {
  const totalValue = routes?.reduce((sum, r) => sum + r.value, 0) ?? 0;
  const totalQuantity = routes?.reduce((sum, r) => sum + r.quantity, 0) ?? 0;
  const totalPickingPositions = routes?.reduce((sum, r) => sum + r.pickingPositionCount, 0) ?? 0;
  const count = routes?.length ?? 0;

  return [
    { title: 'Routes', value: count },
    { title: 'Picking Positions', value: shortenNumber(totalPickingPositions) },
    { title: `Value (${currency})`, value: shortenNumber(totalValue) },
    { title: 'Quantity', value: shortenNumber(totalQuantity) },
  ];
};
